import { render, staticRenderFns } from "./UserReportRatings.vue?vue&type=template&id=64dcd00a&scoped=true"
import script from "./UserReportRatings.vue?vue&type=script&lang=js"
export * from "./UserReportRatings.vue?vue&type=script&lang=js"
import style0 from "./UserReportRatings.vue?vue&type=style&index=0&id=64dcd00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcd00a",
  null
  
)

export default component.exports